import { useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createAuthDs } from './utils/createAuthDs';

export const useDataSource = (
  getSource: ((options?: Object) => any) | object,
  dataGridRef?: any,
  options?: any
) => {
  const jwt = useSelector<any>((state) => state.user.jwt);

  const [unauthorized, setUnauthorized] = useState(false);

  const dispatch = useDispatch();

  const dataSource = useMemo(() => {
    const source =
      typeof getSource === 'object' ? getSource : getSource(options || {});

    return createAuthDs({
      dataSource: source,
      dataGridRef,
      jwt: jwt as string,
      dispatch,
      setUnauthorized
    });
  }, [jwt, options, getSource, dispatch]);

  return { dataSource, unauthorized };
};
